import React, { Component } from 'react';
import ComTable from '../ComTable';

class Licence extends Component {
    state = {
        config: [],
        loading: false,
    }

    componentDidMount() {
        const config = [{
            zh: '执照/许可证/证书名称',
            en: 'Licences/Certificates Name',
            key: 'licencesCertificates',
            width: 550,
        }, {
            zh: '获得证书日期',
            en: 'Certificate Date',
            key: 'certificateDate',
        }];
        this.setState({ config });
    }

    getDataSource = () => {
        const { data, isChinese } = this.props;
        const dataSource = data.map((item, index) => {
            const {
                licencesCertificatesName,
                licencesCertificatesNameEnglish,
                certificateDate,
            } = item;
            return {
                index: index + 1,
                ...item,
                licencesCertificates: `${isChinese ? licencesCertificatesName : licencesCertificatesNameEnglish}`,
                certificateDate: certificateDate.slice(0, 7),
            }
        });
        return dataSource;
    }

    render() {
        const { isChinese } = this.props;
        const { config, loading } = this.state;
        const result = config.map(item => {
            if (isChinese) {
                item.title = item.zh;
            } else {
                item.title = item.en;
            }
            return item;
        });
        return (
            <ComTable
                config={result}
                loading={loading}
                pagination={false}
                getDataSource={this.getDataSource}
            />
        );
    }
}

export default Licence;


// WEBPACK FOOTER //
// ./src/components/common/generateCurriculumVitae/Licence.js